module.exports = __webpack_public_path__ + "img/lettuce-380x380.9586613d.png";